import React, { useEffect, useState } from 'react'
import { createPortal } from 'react-dom'
import { batch } from "@preact/signals-react"

import { AlertsSubtitle, AlertsTabs } from "Pages/ReportsAlerts/Alerts/@components"
import { REPORT_ROUTES } from '@constants'
import { Grid } from "@mui/material"
import { AppFilterPanel, AppStartHint } from "@components"
import PageWrapper from "Pages/@PageWrapper"
import {
	alertsSection,
	isPriceComparisonTabEmpty,
	isNoAvailabilityTabEmpty,
	isPriceChangeTabEmpty,
	isMinMaxPriceTabEmpty,
	isRatingTabEmpty
} from "Pages/ReportsAlerts/Alerts/@signals"
import { ALERTS } from "Pages/ReportsAlerts/Alerts/@constants"
import { NotificationsFilter } from "Pages/ReportsAlerts/Alerts/Notifications/@components"
import PriceComparisonBlock from "Pages/ReportsAlerts/Alerts/Notifications/PriceComparison"
import MinMaxBlock from "Pages/ReportsAlerts/Alerts/Notifications/MinMax"
import NoAvailabilityBlock from "Pages/ReportsAlerts/Alerts/Notifications/NoAvailability"
import PriceChangeBlock from "Pages/ReportsAlerts/Alerts/Notifications/PriceChange"
import RatingBlock from "Pages/ReportsAlerts/Alerts/Notifications/Rating"
import { offices, reports } from "@signals"
import VirtualTourButton, { TourOverlay, TOUR_STEPS } from "./VirtualTour"
import NotificationsDemoData from "./VirtualTour/DemoData"
import { isTourDemoActive } from "@signals/app"


export default function NotificationsPage() {
	const [tourActive, setTourActive] = useState(false)

	useEffect(() => {
		batch(() => {
			alertsSection.value = ALERTS.PRICE_COMPARISON
			offices.value = null
			reports.value = null
			isPriceComparisonTabEmpty.value = false
			isNoAvailabilityTabEmpty.value = false
			isPriceChangeTabEmpty.value = false
			isMinMaxPriceTabEmpty.value = false
			isRatingTabEmpty.value = false
		})
		return () => batch(() => {
			alertsSection.value = ALERTS.PRICE_COMPARISON
			offices.value = null
			reports.value = null
			isPriceComparisonTabEmpty.value = false
			isNoAvailabilityTabEmpty.value = false
			isPriceChangeTabEmpty.value = false
			isMinMaxPriceTabEmpty.value = false
			isRatingTabEmpty.value = false
		})
	}, [])

	return <PageWrapper
		head={"DS Rentacar | Alerts"}
		title={REPORT_ROUTES.NOTIFICATION_TITLE}
		subtitle={<AlertsSubtitle/>}
		actions={<VirtualTourButton onClick={() => { setTourActive(true); isTourDemoActive.value = true }} />}
	>
		<AppFilterPanel toggles={<AlertsTabs/>}>
			<NotificationsFilter />
		</AppFilterPanel>
		{!reports.value && !tourActive && <AppStartHint
			icon="file-chart-column"
			title="Select a report to start"
			description="Pick a report and an office above to see its notifications"
		/>}
		{(!!reports.value || tourActive) && <Grid container spacing={3}>
			<PriceComparisonBlock />
			<MinMaxBlock />
			<NoAvailabilityBlock />
			<PriceChangeBlock />
			<RatingBlock />
		</Grid>}
		{tourActive && <NotificationsDemoData/>}
		{tourActive && createPortal(
			<TourOverlay steps={TOUR_STEPS} onClose={() => { setTourActive(false); isTourDemoActive.value = false }} />,
			document.body
		)}
	</PageWrapper>
}